var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_428_4153",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_428_4153)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.97565 12.7083C9.83996 12.7083 9.71273 12.6846 9.59398 12.6373C9.47523 12.5899 9.36773 12.5164 9.27148 12.4167L5.85482 9C5.64648 8.79166 5.54579 8.54861 5.55273 8.27083C5.55968 7.99305 5.67093 7.75 5.88648 7.54166C6.10148 7.33333 6.3444 7.23263 6.61523 7.23958C6.88607 7.24652 7.12565 7.35416 7.33398 7.5625L8.95898 9.22916V3.35416C8.95898 3.07222 9.05822 2.83159 9.25669 2.63229C9.45516 2.43298 9.69475 2.33333 9.97544 2.33333C10.2561 2.33333 10.4972 2.43298 10.6986 2.63229C10.9 2.83159 11.0007 3.07222 11.0007 3.35416V9.22916L12.6673 7.5625C12.8673 7.35416 13.1048 7.25347 13.3798 7.26041C13.6548 7.26736 13.8998 7.37499 14.1148 7.58333C14.3304 7.79166 14.4347 8.03472 14.4277 8.3125C14.4208 8.59027 14.3132 8.83333 14.1048 9.04166L10.6882 12.4167C10.5863 12.5164 10.4761 12.5899 10.3573 12.6373C10.2386 12.6846 10.1113 12.7083 9.97565 12.7083ZM5.36982 16.6667C4.80801 16.6667 4.32829 16.4667 3.93065 16.0669C3.53287 15.6671 3.33398 15.1865 3.33398 14.625V14.1458C3.33398 13.8639 3.43322 13.6233 3.63169 13.424C3.83016 13.2246 4.06975 13.125 4.35044 13.125C4.63114 13.125 4.87218 13.2246 5.07357 13.424C5.27496 13.6233 5.37565 13.8639 5.37565 14.1458V14.625H14.6257V14.1458C14.6257 13.8639 14.7249 13.6233 14.9234 13.424C15.1218 13.2246 15.3614 13.125 15.6421 13.125C15.9228 13.125 16.1638 13.2246 16.3652 13.424C16.5666 13.6233 16.6673 13.8639 16.6673 14.1458V14.625C16.6673 15.1865 16.4673 15.6671 16.0673 16.0669C15.6673 16.4667 15.1865 16.6667 14.6248 16.6667H5.36982Z",
    fill: "#082A6B"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownload);
export default __webpack_public_path__ + "static/media/download.6c92509d88911d410221f6b95985a232.svg";
export { ForwardRef as ReactComponent };